import { TradingDashboard } from "../components/TradingDashboard";

export default function TraderPage() {
  return <TradingDashboard />;
}
